var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectRiderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEE4E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FEF3F2",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 29.252V31.3414C29.3744 31.1203 28.7013 31 28 31C24.6863 31 22 33.6863 22 37H20C20 32.5817 23.5817 29 28 29C28.6906 29 29.3608 29.0875 30 29.252ZM28 28C24.685 28 22 25.315 22 22C22 18.685 24.685 16 28 16C31.315 16 34 18.685 34 22C34 25.315 31.315 28 28 28ZM28 26C30.21 26 32 24.21 32 22C32 19.79 30.21 18 28 18C25.79 18 24 19.79 24 22C24 24.21 25.79 26 28 26ZM35 32.5858L37.1213 30.4645L38.5355 31.8787L36.4142 34L38.5355 36.1213L37.1213 37.5355L35 35.4142L32.8787 37.5355L31.4645 36.1213L33.5858 34L31.4645 31.8787L32.8787 30.4645L35 32.5858Z",
    fill: "#E60A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectRiderIcon);
export default __webpack_public_path__ + "static/media/reject-rider-icon.dd176ff51f43878ab66da79d0fc920e7.svg";
export { ForwardRef as ReactComponent };